// extracted by mini-css-extract-plugin
export default {"black":"#000000","black25":"rgba(0, 0, 0, 0.25)","white":"#ffffff","content":"k Az","header":"l A4","list-entry":"m","listEntry":"m","set":"n A9","title":"o A8","wrapper":"p"};